module.exports = __webpack_public_path__ + "img/fi.b48413be.svg";